// import Button from "@edusogno/primitives/button.js";
// import { Trans } from "react-i18next";
import { useTranslation } from "react-i18next";
import MobileCourseStructureTemplate from "./MobileCourseStructureTemplate.tsx";
import NoItem from "@/components/NoItem.tsx";

const CourseStructure = ({ course }: { course?: unknown }) => {
  const { t } = useTranslation();
  return (
    <div className="flex-[1_1_100%] min-h-0 gap-2 flex flex-col px-4 py-2 rounded-md h-full bg-white">
      <p className="text-secondary truncate text-center h-fit  text-sm font-semibold">
        {/* <Trans
          i18nKey="home.course.course_structure"
          defaults="Your course structure"
        /> */}
        {(course as { course_name?: string })?.course_name}
      </p>
      <div className="flex flex-[1_1_0] flex-col h-full w-full">
        {course ? (
          <MobileCourseStructureTemplate course={course as never} />
        ) : (
          <NoItem
            className="m-auto bg-gradient h-full !min-h-[100%] text-white rounded-[7px] w-full"
            text={t("home.course.not_available")}
          />
        )}
      </div>
      {/* <div className="flex h-fit flex-row w-full items-center pt-2 gap-4 px-2">
        <div className="flex flex-row items-center gap-4">
          <p className="text-xs leading-[120%]">
            <Trans
              i18nKey="home.course.watch_video_message_mobile"
              defaults="Watch the video for detailed course specifics"
            />
          </p>
        </div>
        <Button size="sm">
          <Trans i18nKey="home.course.watch_video" defaults="Watch video" />
        </Button>
      </div> */}
    </div>
  );
};
export default CourseStructure;
